import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NoConnectionService {
  isOffline = new BehaviorSubject<boolean>(false);
  cachedRequest = new BehaviorSubject<any>(null);
}
